<template>
  <div>
    <div class="blockcont">
      <div class="smalltitle">WikiAllergies EMR On Boarding Procedure</div>
      <div>
        <p>In order to let a user sending medication electronically, we would need to verify her identity as what she
          claims. We also need to verify her medical license.</p>
        <p>For physicians or midlevel's, setup at WikiAllergies.com physician account by following those steps
          below:</p>
        <ul>
          <li>1. Register a doctor account at WikiAllergies.com and Clinic account at WikiAllergies.com. User need to
            look up NPI for each account at the public database link if they do not know the NPI.
          </li>
          <li>2. User has to have access to a computer with Chrome browser or similar and a smart phone with the number
            matches that of the phone bill.
          </li>
          <li>3. Go to UPDATE PROFILE on the left column next to the avatar.</li>
          <li>4. Click on Account Setting, update Cell Phone number that matches the phone bill that will be uploaded at
            step (5).
          </li>
          <li>5. Register provider with Surescripts at SURESCRIPTS STATUS > click on Deactivated to open "Create
            Provider Location".
          </li>
          <li>
            6. Click on EMR Setup tab, choose CREDENTIALS page and upload proof of.
            <ul style="list-style-type: circle !important;">
              <li style="list-style: circle !important;">Copy of active state issued medical license.</li>
              <li style="list-style: circle !important;">Copy of past or current ABAI board certificates (optional,
                preferable).
              </li>
            </ul>
          </li>
          <li>
            7. Same at EMR Setup tab, choose ID proofing, upload current cell phone bill that matches user's name and
            cell phone number.
          </li>
          <li>
            8. Go to Trizetto site link and setup and account with Trizetto for insurance billing.
          </li>
        </ul>
        <p>
          After having those information updated, we will send her a text message to link to a ID Proof service. User
          needs to complete ID biometric proof and knowledge base questionnaire completed. After user's identity is
          verified, we will activate WikiAllergies EMR and e-prescribe function.
        </p>
        <p>For WikiAllergies Staff</p>
        <ul>
          <li>1. Verify phone number matches user name and phone number in the cell phone bill uploaded by user</li>
          <li>2. Send a link for ID Proof to verified cell phone number from step (1)</li>
          <li>3. Verify two (2) steps verifications are success: 1. Driver License, 2. Criminal Federal</li>
          <li>3. Activate WikiAllergies EMR and e-prescribe</li>
          <li>4. Let coding team know to register provider with Surescripts</li>
          <li>5. Check with Trizetto to implement billing services</li>
        </ul>
      </div>
      <div class="smalltitle">WikiAllergies EMR EPCS Standard Operation Procedure</div>
      <div>
        <p>1. Objective</p>
        <ul>
          <li>1.1 This Standard Operating Procedure (SOP) describes the standard procedure for staff regarding handling of Electronic Prescription for Controlled Substance (EPCS) for WikiAllergies Staff.</li>
        </ul>
        <p>2. EPCS Activation</p>
        <ul>
          <li>2.1 Verify provider DEA and expiration date. DEA license is uploaded by the practioner at his/her WikiAllergies account or by clinic staff at Security page. Expiration date is declared by user at each uploaded DEA.</li>
          <li>2.2 Activate EPCS for the practioner if DEA license present and not expired</li>
          <li>
            2.3 Activation of EPCS will be done at <a href="https://sales.wikiallergies.com">sales.wikiallergies.com</a> and requiring these steps
            <ul>
              <li>2.3.1 From Surescripts Status, open the e-Rx and EPCS window</li>
              <li>2.3.2 Add "ControlledSubstance" to the "Service Levels" box then clinic Submit for Approval</li>
              <li>
                2.3.3 Verification process requiring two WikiAllergies staff signature requiring 2FA and at lease one user holding an active DEA license
              </li>
            </ul>
          </li>
        </ul>
        <p>3. EPCS Deactivation</p>
        <ul>
          <li>3.1 WikiAllergies EMR automatically block user’s ability to send controlled substance the declared DEA license is expired.</li>
          <li>3.2 WikiAllergies will notify user to update their DEA license</li>
          <li>3.3 WikiAllergies staff will randomly audit declared DEA license expiration date</li>
          <li>3.4 WikiAllergies staff disable EPCS if there is false statement and notify user of discrepancy in their declaration of DEA license or being notified that the practioner’s DEA is revoked.</li>
          <li>
            3.5 Deactivation of EPCS will be done at sales. <a href="https://wikiallergies.com">wikiallergies.com</a> by the same step as at 2.3
            <ul>
              <li>3.5.1 From Surescripts Status, open the e-Rx and EPCS window</li>
              <li>3.5.2 Remove "ControlledSubstance" to the "Service Levels" box then clinic Submit for Approval</li>
              <li>3.5.3 Verification process requiring two WikiAllergies staff signature requiring 2FA and at lease one user holding an active DEA license</li>
            </ul>
          </li>
        </ul>
        <p>4.Record keeping of incidents: notification of expired DEA, revoked DEA or discrepancy in DEA declaration</p>
        <ul>
          <li>
            4.1 Each incident would automatically log at EPCS incident page
          </li>
          <li>
            4.2 WikiAllergies staff would upload relevance document to each report
          </li>
        </ul>
        <p>5 iBeta will audit EPCS compliance every two years</p>
        <ul>
          <li>5.1 In the event of losing EPCS compliant, WikiAllergies staff would follow these steps
            <ul>
              <li>5.1.1 iBeta will audit EPCS compliance every two years. In the event of losing EPCS compliant, WikiAllergies staff would follow these steps</li>
              <li>5.1.2 Deactivate system EPCS function for all users</li>
            </ul>
          </li>
          <li>5.2 When WikiAllergies reobtain EPCS certification by iBeta or when regaining EPCS compliance certificate. WikiAllergies staff would follow those instructions below
            <ul>
              <li>5.2.1 Notify all EPCS users that WikiAllergies EMR has regained EPCS certificate and controlled substance prescription is available for use.</li>
              <li>5.2.2 Activate system EPCS function for previous EPCS users</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="smalltitle">The SMS consent policy</div>
      <div>
        The customer message us first after getting our information from our website <a href="https://wikiallergies.com" target="_blank">https://wikiallergies.com</a>, at the same time the customer needs to fill out a form on our contact us page <a href="https://wikiallergies.com/sign-up" target="_blank">https://wikiallergies.com/sign-up</a> giving us his/her consent to send text messages to them and they agree to our privacy policy terms and conditions on the same page <a href="https://wikiallergies.com/privacy-policy" target="_blank">https://wikiallergies.com/privacy-policy</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../client'
import Common from '../mixins/Common'

export default {
  name: 'ProcedureAndSOP',
  mixins: [Common],
  data () {
    return {}
  },
  computed: {},
  mounted () {

  },

  methods: {}
}
</script>

<style scoped>

</style>
